import React from "react";
import Canva from "./canva";

export function App() {
  return (
  <>
  <Canva/>
  </>
  );
}

export default App;
